import FlightDelayedModal from './FlightDelayedModal';

export default FlightDelayedModal;
